import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import Error from "./Error";
import { connect } from "react-redux";
import LoadingIndicator from "../common/LoadingIndicator";
import { editRestaurant } from "../../store/actions/RestaurantActions";

const schema = yup.object().shape({
  address: yup.string().required("Campo requerido"),
  startTime: yup.string().required("Campo requerido"),
  endTime: yup.string().required("Campo requerido"),
  pricePerKilometer: yup
    .number()
    .min(0, "Precio por km debe ser mayor a 0.")
    .typeError("Precio por km debe ser un número.")
    .required("Campo requerido."),
  radius: yup
    .number()
    .min(0, "Radio de entregas debe ser mayor a 0.")
    .typeError("Radio de entregas debe ser un número.")
    .required("Campo requerido."),
  minOrderTotal: yup
    .number()
    .min(0, "Total mínimo de orden debe ser mayor a 0.")
    .typeError("Total mínimo de orden debe ser un número.")
    .required("Campo requerido."),
  estimatedTime: yup
    .number()
    .min(0, "Tiempo estimado de entrega debe ser mayor a 0 (min).")
    .typeError("Tiempo estimado de entrega debe ser un número.")
    .required("Campo requerido."),
  latitude: yup.string().required("Campo requerido"),
  longitude: yup.string().required("Campo requerido"),
  available: yup.boolean(),
});

const RestaurantForm = ({
  loading,
  address,
  startTime,
  endTime,
  pricePerKilometer,
  radius,
  minOrderTotal,
  estimatedTime,
  latitude,
  longitude,
  available,
  id,
  editRestaurant,
  error,
  success,
}) => {
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    defaultValues: { startTime, endTime, pricePerKilometer, radius },
  });

  const submit = (values) => {
    editRestaurant(id, values);
  };

  useEffect(() => {
    if (
      address &&
      startTime &&
      endTime &&
      isNaN(pricePerKilometer) &&
      !isNaN(radius) &&
      !isNaN(minOrderTotal) &&
      !isNaN(estimatedTime) &&
      latitude &&
      longitude
    )
      reset({
        address,
        startTime,
        endTime,
        pricePerKilometer,
        minOrderTotal,
        radius,
        estimatedTime,
        latitude,
        longitude,
      });
  }, [
    address,
    startTime,
    endTime,
    pricePerKilometer,
    radius,
    minOrderTotal,
    estimatedTime,
    latitude,
    longitude,
  ]);

  if (loading) return <LoadingIndicator />;

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="mb-4 w-full">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="address"
        >
          Nombre sucursal (Dirección)
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          name="address"
          ref={register}
          placeholder="Dirección"
          defaultValue={address}
        />
        <Error error={errors.address} left></Error>
      </div>
      <div className="flex">
        <div className="mb-4 w-full mr-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="address"
          >
            Latitud
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name="latitude"
            ref={register}
            placeholder="Latitud"
            defaultValue={latitude}
          />
          <Error error={errors.latitude} left></Error>
        </div>
        <div className="mb-4 w-full">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="endTime"
          >
            Longitud
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name="longitude"
            ref={register}
            placeholder="Longitud"
            defaultValue={longitude}
          />
          <Error error={errors.longitude} left></Error>
        </div>
      </div>
      <div className="flex">
        <div className="mb-4 w-full mr-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="startTime"
          >
            Inicio
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name="startTime"
            ref={register}
            placeholder="Inicio del día"
            defaultValue={startTime}
          />
          <Error error={errors.startTime} left></Error>
        </div>
        <div className="mb-4 w-full">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="endTime"
          >
            Fin
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="time"
            name="endTime"
            ref={register}
            placeholder="Fin del día"
            defaultValue={endTime}
          />
          <Error error={errors.endTime} left></Error>
        </div>
      </div>
      <div className="mb-4 w-full">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="pricePerKilometer"
        >
          Precio por kilómetro
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="number"
          name="pricePerKilometer"
          ref={register}
          placeholder="Precio por kilómetro"
          defaultValue={pricePerKilometer}
        />
        <Error error={errors.pricePerKilometer} left></Error>
      </div>
      <div className="mb-4 w-full">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="radius"
        >
          Radio de entrega
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="number"
          name="radius"
          ref={register}
          placeholder="Radio de entrega"
          defaultValue={radius}
        />
        <Error error={errors.radius} left></Error>
      </div>
      <div className="mb-4 w-full">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="minOrderTotal"
        >
          Mínimo total de orden.
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="number"
          name="minOrderTotal"
          ref={register}
          placeholder="Mínimo total de orden."
          defaultValue={minOrderTotal}
        />
        <Error error={errors.minOrderTotal} left></Error>
      </div>
      <div className="mb-4 w-full">
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor="estimatedTime"
        >
          Tiempo estimado de entrega (min).
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="number"
          name="estimatedTime"
          ref={register}
          placeholder="Tiempo estimado de entrega (min)."
          defaultValue={estimatedTime}
        />
        <Error error={errors.estimatedTime} left></Error>
      </div>
      <div className="mb-4 w-full input">
        <div className="flex items-center">
          <input
            className="border rounded focus:outline-none focus:shadow-outline"
            type="checkbox"
            name={"available"}
            ref={register}
            defaultChecked={available}
          />
          <label
            className="block text-gray-700 text-sm font-bold ml-2"
            htmlFor="title"
          >
            Disponible
          </label>
        </div>
        <Error error={errors ? errors.available : null} left></Error>
      </div>
      <div className="flex items-center justify-between flex-wrap">
        <button
          type="submit"
          className="block bg-brand-300 rounded-md text-brand-800 py-2 px-4 text-sm font-bold border-2 border-brand-700"
        >
          Subir datos
        </button>
      </div>
      <Error error={error} left></Error>
    </form>
  );
};

const mapStateToProps = (state) => {
  return { ...state.restaurant.restaurantActions };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editRestaurant: (restaurantId, restaurant) =>
      dispatch(editRestaurant(restaurantId, restaurant)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantForm);
